import { render, staticRenderFns } from "./PublicAsambleaList.vue?vue&type=template&id=8011aade&scoped=true"
import script from "./PublicAsambleaList.vue?vue&type=script&lang=js"
export * from "./PublicAsambleaList.vue?vue&type=script&lang=js"
import style0 from "./PublicAsambleaList.vue?vue&type=style&index=0&id=8011aade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8011aade",
  null
  
)

export default component.exports